/* Live price list from Dibs.
   Reads the public service list of the business page (the same data the Dibs booking page shows),
   so prices are never copied by hand: change a price in Dibs and this list changes too.
   - Shows only services that are visible to customers, with a visible price, in the same order as on the Dibs page.
   - "Starting from" prices get the "החל מ-" prefix.
   - Keeps the answer in sessionStorage for 10 minutes; if Dibs can't be reached, shows a friendly fallback.
   All text from Dibs is inserted with textContent (never as HTML). */
(function () {
  var CACHE_MS = 10 * 60 * 1000;

  function fetchJSON(url) {
    return fetch(url, { method: 'GET' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function load(api, biz) {
    var key = 'tdh-dibs-' + biz;
    try {
      var cached = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (cached && Date.now() - cached.t < CACHE_MS) return Promise.resolve(cached.d);
    } catch (e) { /* ignore */ }
    return Promise.all([
      fetchJSON(api + '/businesses/' + biz),
      fetchJSON(api + '/businesses/' + biz + '/services')
    ]).then(function (res) {
      var data = { business: res[0], services: res[1] };
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: data })); } catch (e) { /* ignore */ }
      return data;
    });
  }

  function ordered(data) {
    var list = (data.services || []).filter(function (s) {
      return s && !s.isDeleted && s.isVisibleToCustomers !== false &&
        s.isPriceVisibleToCustomers !== false && typeof s.price === 'number';
    });
    var ids = (data.business && data.business.services) || [];
    var pos = {};
    ids.forEach(function (id, i) { pos[typeof id === 'string' ? id : id && id._id] = i; });
    list.sort(function (a, b) {
      var pa = pos[a._id] === undefined ? 1e6 : pos[a._id];
      var pb = pos[b._id] === undefined ? 1e6 : pos[b._id];
      return pa - pb;
    });
    return list;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined) n.textContent = text;
    return n;
  }

  function render(root, services) {
    var list = root.querySelector('[data-list]');
    var max = parseInt(root.getAttribute('data-max'), 10) || 0;
    var withDesc = root.getAttribute('data-descriptions') === 'true';
    var withDur = root.getAttribute('data-duration') === 'true';
    var fromLabel = root.getAttribute('data-from') || '';
    var minLabel = root.getAttribute('data-minutes') || '';
    var fmt = new Intl.NumberFormat('he-IL');
    var shown = max > 0 ? services.slice(0, max) : services;

    list.textContent = '';
    shown.forEach(function (s) {
      var amount = (s.isStartFromPrice ? fromLabel : '') + fmt.format(s.price) + ' ₪';
      var desc = (s.description || '').trim();
      var dur = withDur && !s.hideServiceDuration && s.durationTime ? s.durationTime + ' ' + minLabel : '';
      var li = el('li', 'dibs-price');

      var row = el('span', 'dibs-price__row');
      var name = el('span', 'dibs-price__name', s.name);
      name.setAttribute('dir', 'auto');
      row.appendChild(name);
      row.appendChild(el('span', 'dibs-price__dots'));
      row.appendChild(el('span', 'dibs-price__amount', amount));

      if (withDesc && (desc || dur)) {
        var d = document.createElement('details');
        d.className = 'dibs-price__details';
        var sum = document.createElement('summary');
        sum.appendChild(row);
        d.appendChild(sum);
        var body = el('div', 'dibs-price__body');
        if (desc) { var p = el('p', 'dibs-price__desc', desc); p.setAttribute('dir', 'auto'); body.appendChild(p); }
        if (dur) body.appendChild(el('p', 'dibs-price__meta', dur));
        d.appendChild(body);
        li.appendChild(d);
      } else {
        li.appendChild(row);
      }
      list.appendChild(li);
    });

    var more = root.querySelector('[data-more]');
    if (more) more.hidden = !(max > 0 && services.length > max);
  }

  function init(root) {
    if (root.getAttribute('data-inited')) return;
    root.setAttribute('data-inited', '1');
    var api = (root.getAttribute('data-api') || 'https://rest-api.dibs-app.com').replace(/\/+$/, '');
    var biz = root.getAttribute('data-business');
    var list = root.querySelector('[data-list]');
    var error = root.querySelector('[data-error]');
    if (!biz) { list.textContent = ''; error.hidden = false; return; }
    load(api, biz).then(function (data) {
      var services = ordered(data);
      if (!services.length) throw new Error('no services');
      render(root, services);
    }).catch(function () {
      list.textContent = '';
      error.hidden = false;
    });
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-dibs-prices]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
